<template lang="pug">
.delete-button-container.no-select(@mousedown="startCounter" @mouseup="restartCounter" @mouseleave="restartCounter" @touchstart="startCounter" @touchend="restartCounter")
  a.delete-icon-container
    .delete-text {{ textButton }}
    .text-delete-instructions(v-if="interval") {{ ' ' }} {{ seconds - secondsPressed }}s
</template>

<script>
import mHoldDown from '@/mixins/holdDown'

export default {
  name: 'HoldButton',

  mixins: [mHoldDown],

  props: {
    textButton: String,
    textDescription: String,
    seconds: Number
  },

  methods: {
    onCounterFinish () {
      this.restartCounter()
      this.$emit('action')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/HoldButton.vue